/**
 * API-Only City Datepicker Restriction Module (Desktop)
 *
 * When a city has only API providers (no local providers),
 * same-day booking is not possible. This module adjusts the
 * jQuery UI Datepicker minDate accordingly:
 * - API-only city: minDate = 1 (tomorrow)
 * - City with local providers: minDate = 0 (today)
 *
 * Listens to stationSelected/citySelected events from city-autocomplete.js
 * and geolocation-city.js.
 *
 * @version 1.0.0
 */
(function($) {
    'use strict';

    // Datepicker field selectors for all search form tabs
    var datepickerFields = [
        '#anmietdatum', '#rueckgabedatum',                           // LKW Tab
        '#anmietdatum-transporter', '#rueckgabedatum-transporter',   // Transporter Tab
        '#nutz-anmietdatum', '#nutz-rueckgabedatum'                  // Nutzfahrzeuge Tab
    ];

    /**
     * Update minDate on all datepicker fields
     * @param {number} minDate - 0 for today, 1 for tomorrow
     */
    function updateMinDate(minDate) {
        datepickerFields.forEach(function(selector) {
            var $field = $(selector);
            if ($field.length && $field.hasClass('hasDatepicker')) {
                var currentVal = $field.datepicker('getDate');
                $field.datepicker('option', 'minDate', minDate);

                // If today was already selected and we switched to API-only, bump to tomorrow
                if (minDate > 0 && currentVal) {
                    var today = new Date();
                    today.setHours(0, 0, 0, 0);
                    var selectedDay = new Date(currentVal);
                    selectedDay.setHours(0, 0, 0, 0);

                    if (selectedDay.getTime() === today.getTime()) {
                        var tomorrow = new Date(today);
                        tomorrow.setDate(tomorrow.getDate() + 1);
                        $field.datepicker('setDate', tomorrow);
                    }
                }
            }
        });
    }

    /**
     * Handle city/station selection event
     * @param {Event} event
     * @param {Object} data - Event data with api_only flag
     */
    function onCitySelected(event, data) {
        if (!data) return;

        var minDate = data.api_only ? 1 : 0;
        updateMinDate(minDate);
    }

    // Listen for city/station selection events
    $(document).on('stationSelected', onCitySelected);
    $(document).on('citySelected', onCitySelected);

})(jQuery);
